import { useEffect } from 'react';
import { motion } from 'framer-motion';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import { Link } from 'react-router-dom';

const STSPanelPage = () => {
  useEffect(() => {
    document.title = '삼원테크 | STS패널형 물탱크 - 3톤~250톤 조립식 스테인리스 물탱크';
    document.querySelector('meta[name="description"]')?.setAttribute(
      'content',
      '삼원테크 STS패널형 물탱크. 3톤~250톤 대용량 조립식 스테인리스 물탱크. STS304 재질, 10단계 제작 공정, ISO9001 품질 인증. 현장 맞춤 제작 및 설치.'
    );
    const schema = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "STS패널형 물탱크",
      "description": "조립식 구조로 현장 설치가 용이하며, 대용량 저수 시설에 최적화된 스테인리스 물탱크. 3톤~250톤.",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/process/sts-panel`,
      "brand": { "@type": "Brand", "name": "삼원테크" },
      "manufacturer": {
        "@type": "Organization",
        "name": "삼원테크",
        "url": import.meta.env.VITE_SITE_URL || 'https://example.com'
      },
      "material": "STS304 스테인리스 스틸",
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "KRW",
        "seller": { "@type": "Organization", "name": "삼원테크" }
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "홈", "item": import.meta.env.VITE_SITE_URL || 'https://example.com' },
          { "@type": "ListItem", "position": 2, "name": "제작과정", "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/process` },
          { "@type": "ListItem", "position": 3, "name": "STS패널형 물탱크", "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/process/sts-panel` }
        ]
      }
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'schema-sts-panel';
    script.text = JSON.stringify(schema);
    document.head.appendChild(script);
    return () => { document.getElementById('schema-sts-panel')?.remove(); };
  }, []);

  const processSteps = [
    {
      step: '01',
      title: '판넬제작 시공설계',
      description: '현장 조사를 통해 최적의 설계안을 작성하고, 고객 요구사항을 반영한 상세 도면을 제작합니다.',
      icon: 'ri-draft-line',
      image: 'https://public.readdy.ai/ai/img_res/74154f5026de91a13aeda64434652c50.jpg'
    },
    {
      step: '02',
      title: '프레스판 가공작업',
      description: 'STS304 또는 STS316 등 고품질 스테인리스 스틸을 사용하여 정밀하게 프레스판을 가공합니다.',
      icon: 'ri-tools-line',
      image: 'https://static.readdy.ai/image/75975fdd6a8419c14194c00fe1023b5f/ce8ca48fe59057e01e93852490fd7e8e.png'
    },
    {
      step: '03',
      title: '기초 CHANNEL 작업',
      description: '물탱크 설치를 위한 견고한 기초 콘크리트 패드(발주처 제공)를 시공하고, 물탱크 하부 구조를 지지하는 기초 잔넬을 연속 설치합니다.',
      icon: 'ri-building-line',
      image: 'https://static.readdy.ai/image/75975fdd6a8419c14194c00fe1023b5f/d1d65b8f96bc46095198e14694774f6c.png'
    },
    {
      step: '04',
      title: '밑판 설치 작업',
      description: '물탱크의 바닥면이 되는 밑판을 정밀하게 설치합니다.',
      icon: 'ri-layout-bottom-line',
      image: 'https://static.readdy.ai/image/75975fdd6a8419c14194c00fe1023b5f/211b389295c6b42b2368ce234392dc33.png'
    },
    {
      step: '05',
      title: '측판 설치 작업',
      description: '물탱크의 측면 패널을 순차적으로 조립하고 용접합니다.',
      icon: 'ri-layout-grid-line',
      image: 'https://static.readdy.ai/image/75975fdd6a8419c14194c00fe1023b5f/281d4f74d0b8e7472e23f1f2e80547f2.png'
    },
    {
      step: '06',
      title: '수평,수직 보강 앵글 작업',
      description: '물탱크의 구조적 안정성을 위한 수평 및 수직 보강 앵글을 설치합니다.',
      icon: 'ri-grid-line',
      image: 'https://static.readdy.ai/image/75975fdd6a8419c14194c00fe1023b5f/a55ec1f1bb70ed8afec39b99d1f65223.png'
    },
    {
      step: '07',
      title: '우레탄 성형폼 설치작업',
      description: '단열 및 보온을 위한 우레탄 성형폼을 설치합니다.',
      icon: 'ri-temp-cold-line',
      image: 'https://static.readdy.ai/image/75975fdd6a8419c14194c00fe1023b5f/532a4ba75105f843e636fe2f2a54bbe1.png'
    },
    {
      step: '08',
      title: '알루미늄 케이싱 설치작업',
      description: '외부 마감재로 알루미늄 케이싱을 설치하여 외관을 완성합니다.',
      icon: 'ri-box-3-line',
      image: 'https://static.readdy.ai/image/75975fdd6a8419c14194c00fe1023b5f/b57be8c124ba72cd594e9dab5f88d62b.png'
    },
    {
      step: '09',
      title: '내부코팅 작업(선택)',
      description: '필요시 물탱크 내부에 추가 코팅 작업을 진행합니다.',
      icon: 'ri-paint-brush-line',
      image: 'https://static.readdy.ai/image/75975fdd6a8419c14194c00fe1023b5f/ead094d5b603979b44dbfe08eb395956.png'
    },
    {
      step: '10',
      title: '담수(발주처 공급)',
      description: '최종 검사 후 발주처에서 물을 공급하여 물탱크 제작을 완료합니다.',
      icon: 'ri-water-flash-line',
      image: 'https://readdy.ai/api/search-image?query=completed%20stainless%20steel%20panel%20water%20tank%20being%20filled%20with%20clean%20water%20showing%20final%20commissioning%20and%20water%20filling%20process&width=800&height=500&seq=panel-step12&orientation=landscape'
    }
  ];

  const features = [
    {
      icon: 'ri-puzzle-line',
      title: '모듈형 설계',
      description: '현장 조건에 맞춰 자유로운 크기 조절이 가능합니다'
    },
    {
      icon: 'ri-time-line',
      title: '빠른 시공',
      description: '용접식 구조로 공기를 단축할 수 있습니다'
    },
    {
      icon: 'ri-tools-line',
      title: '유지보수 용이',
      description: '패널 단위로 교체 및 보수가 가능합니다'
    },
    {
      icon: 'ri-water-flash-line',
      title: '대용량 가능',
      description: '3톤부터 제작 가능합니다'
    },
    {
      icon: 'ri-shield-star-line',
      title: '내식성 우수',
      description: 'STS 소재로 부식에 강하고 위생적입니다'
    },
    {
      icon: 'ri-ruler-line',
      title: '맞춤 제작',
      description: '고객 요구사항에 맞는 맞춤형 제작이 가능합니다'
    }
  ];

  const advantages = [
    {
      number: '01',
      icon: 'ri-shield-flash-line',
      title: '강도가 크다',
      description: '고강도 스테인리스 스틸 소재를 사용하여 외부 충격과 하중에 강한 내구성을 자랑합니다.'
    },
    {
      number: '02',
      icon: 'ri-sparkling-line',
      title: '청결성이 좋으며 위생적이다',
      description: '스테인리스 소재 특성상 세균 번식이 억제되고, 내부 오염이 없어 항상 깨끗하고 위생적인 물을 공급합니다.'
    },
    {
      number: '03',
      icon: 'ri-money-dollar-circle-line',
      title: '경제적이다',
      description: '합리적인 가격으로 제작 가능하며, 유지보수 비용이 낮아 장기적으로 경제적인 선택입니다.'
    },
    {
      number: '04',
      icon: 'ri-star-line',
      title: '외관이 미려하며 수명이 오래간다',
      description: '세련된 스테인리스 외관으로 미적 완성도가 높으며, 반영구적인 수명으로 오랫동안 사용할 수 있습니다.'
    },
    {
      number: '05',
      icon: 'ri-fire-line',
      title: '내열성, 내충격성이 좋다',
      description: '높은 온도 변화에도 변형이 없으며, 외부 충격에도 강한 내구성을 유지합니다.'
    },
    {
      number: '06',
      icon: 'ri-settings-3-line',
      title: '용량이 다양하며 현장시공이 용이하다',
      description: '소형부터 대형까지 다양한 용량으로 제작 가능하며, 조립식 구조로 현장 시공이 간편합니다.'
    }
  ];

  const specifications = [
    { label: '재질', value: 'STS304, STS316 등' },
    { label: '용량 범위', value: '3톤 ~' },
    { label: '패널 크기', value: '1,000mm × 1,000mm (표준)' },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 text-white py-24">
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12 relative z-10">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="flex items-center gap-3 mb-6">
                <Link to="/process" className="text-teal-200 hover:text-white transition-colors cursor-pointer">
                  제작과정
                </Link>
                <i className="ri-arrow-right-s-line text-teal-200"></i>
                <span>STS패널형 물탱크</span>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight">
                STS패널형 물탱크
              </h1>
              <p className="text-xl md:text-2xl text-teal-50 max-w-3xl leading-relaxed whitespace-nowrap">
                용접식 구조로 현장 설치가 용이하며, 대용량 저수 시설에 최적화된 제품입니다
              </p>
            </motion.div>
          </div>
        </section>

        {/* Product Image */}
        <section className="py-20 bg-white">
          <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12">
            <div className="relative w-full h-[600px] rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/75975fdd6a8419c14194c00fe1023b5f/a877f752cea0529257985a19529d7064.png"
                alt="STS패널형 물탱크"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-8 left-8">
                <span className="bg-teal-600 text-white px-6 py-2 rounded-full text-sm font-semibold">
                  삼원테크 STS패널형 물탱크
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Advantages Section */}
        <section className="py-20 bg-gradient-to-br from-teal-50 via-white to-teal-50">
          <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12">
            <div className="text-center mb-16">
              <span className="inline-block bg-teal-100 text-teal-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">ADVANTAGES</span>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                스테인리스 패널형 물탱크의 장점
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
                삼원테크의 STS패널형 물탱크는 품질과 신뢰성으로 검증된 제품입니다
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {advantages.map((adv, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white rounded-2xl p-8 shadow-md hover:shadow-xl transition-all duration-300 border border-teal-100 group"
                >
                  <div className="flex items-start gap-5 mb-5">
                    <div className="text-5xl font-extrabold text-teal-100 group-hover:text-teal-200 transition-colors leading-none select-none">
                      {adv.number}
                    </div>
                    <div className="w-14 h-14 bg-teal-600 rounded-xl flex items-center justify-center text-white text-2xl flex-shrink-0">
                      <i className={adv.icon}></i>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {adv.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-sm">
                    {adv.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Features */}
        <section className="py-20 bg-gradient-to-br from-gray-50 via-white to-gray-50">
          <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                제품 특징
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
                STS패널형 물탱크의 주요 특징과 장점을 확인하세요
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {features.map((feature, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
                >
                  <div className="w-16 h-16 bg-teal-600 rounded-xl flex items-center justify-center text-white text-3xl mb-6">
                    <i className={feature.icon}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Process Steps */}
        <section className="py-20 bg-white">
          <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                제작 과정
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
                체계적인 10단계 제작 프로세스로 최고 품질을 보장합니다
              </p>
            </div>

            <div className="space-y-8">
              {processSteps.map((step, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  className="bg-white rounded-3xl overflow-hidden border border-teal-100 hover:shadow-2xl transition-all duration-300"
                >
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
                    <div className={`p-8 md:p-12 flex flex-col justify-center ${index % 2 === 0 ? 'lg:order-1' : 'lg:order-2'}`}>
                      <div className="flex items-center gap-6 mb-6">
                        <div className="text-6xl font-bold text-teal-600/20">
                          {step.step}
                        </div>
                        <div className="w-20 h-20 bg-teal-600 rounded-2xl flex items-center justify-center text-white text-3xl flex-shrink-0">
                          <i className={step.icon}></i>
                        </div>
                      </div>
                      <h3 className="text-3xl font-bold text-gray-900 mb-4">
                        {step.title}
                      </h3>
                      <p className="text-lg text-gray-600 leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                    <div className={`relative h-[400px] ${index % 2 === 0 ? 'lg:order-2' : 'lg:order-1'}`}>
                      <img
                        src={step.image}
                        alt={step.title}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Specifications */}
        <section className="py-20 bg-gradient-to-br from-gray-50 via-white to-gray-50">
          <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
                제품 사양
              </h2>
              <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
                STS패널형 물탱크의 상세 사양을 확인하세요
              </p>
            </div>

            <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-gray-200">
                {specifications.map((spec, index) => (
                  <div key={index} className="p-8 text-center hover:bg-teal-50 transition-colors duration-300">
                    <div className="text-sm font-semibold text-teal-600 mb-2 uppercase tracking-wide">
                      {spec.label}
                    </div>
                    <div className="text-2xl font-bold text-gray-900">
                      {spec.value}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-white">
          <div className="max-w-[1600px] mx-auto px-4 md:px-8 lg:px-12">
            <div className="bg-gradient-to-br from-teal-600 via-teal-700 to-teal-800 rounded-3xl p-12 md:p-16 text-center text-white shadow-2xl">
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                STS패널형 물탱크 제작 상담
              </h2>
              <p className="text-xl text-teal-50 mb-8 max-w-2xl mx-auto leading-relaxed">
                전문 상담원이 고객님의 요구사항에 맞는 최적의 솔루션을 제안해드립니다
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/quote"
                  className="inline-block bg-white text-teal-600 px-10 py-4 rounded-full font-bold text-lg hover:bg-teal-50 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  상담 문의하기
                </Link>
                <Link
                  to="/products"
                  className="inline-block bg-teal-500 text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-teal-400 transition-all duration-300 shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  다른 제품 보기
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default STSPanelPage;